/**
 * Prefixed localStorage wrapper for multi-app isolation.
 *
 * All three apps (admin, comanda, carta) share the same origin under
 * dev.nerdo.solutions/resto/{app}. This utility namespaces localStorage
 * keys so they don't collide.
 */

const STORAGE_PREFIX = 'comanda_';

export const storage = {
  get: (key) => localStorage.getItem(STORAGE_PREFIX + key),
  set: (key, value) => localStorage.setItem(STORAGE_PREFIX + key, value),
  remove: (key) => localStorage.removeItem(STORAGE_PREFIX + key),
};

/**
 * One-time migration: copies old un-prefixed keys to prefixed keys,
 * then removes the old ones. Safe to call multiple times — skips if
 * the migration flag is already set.
 */
const MIGRATION_FLAG = 'comanda_storage_migrated';

const KNOWN_KEYS = [
  'selectedOrganizationId',
  'selectedOrganizationName',
  'selectedRestaurantId',
  'selectedRestaurantName',
  'userRole',
  'allRestaurants',
  'comanda-theme',
  'comanda-preferred-view',
  'comanda_screen_pin',
  'comanda_pin_configured',
  'comanda_unlock_token',
  'comanda_unlock_nonce',
  'comanda_screen_lock_timestamp',
  'comanda_failed_attempts',
  'comanda_lockout_until',
  'comanda_screen_locked',
  'notification-prompt-dismissed',
];

export function migrateLocalStorageKeys() {
  if (localStorage.getItem(MIGRATION_FLAG)) return;

  KNOWN_KEYS.forEach((key) => {
    const value = localStorage.getItem(key);
    if (value !== null) {
      localStorage.setItem(STORAGE_PREFIX + key, value);
      localStorage.removeItem(key);
    }
  });

  localStorage.setItem(MIGRATION_FLAG, 'true');
}
